// Copyright (c) Docugami, Inc. All rights reserved.

import { ReportEntry } from "networking/reportsApi";
import styled from "styled-components";
import { CardBindingSuggestions } from "./CardBindingSuggestions";
import { CardletLabel } from "./CardStyles";

const FooterRoot = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    flex: 1;
    gap: 5px;
    flex-direction: column;
`

export enum ReportItemType {
    ReportEntry = 'ReportEntry',
    ReportEntryGroup = 'ReportEntryGroup'
}

export interface IReportEntryItemGroup extends IReportItem {
    type: ReportItemType.ReportEntryGroup;
    name: string;
    groupItems: IReportEntryItem[];
}

export interface IReportEntryItem extends IReportItem {
    type: ReportItemType.ReportEntry;
    entry: ReportEntry;
    isEvaluating: boolean;
    isLinkable?: boolean;
}

export interface IReportItem {
    id: string;
    type: ReportItemType;
    reportId: string;
    isSelected?: boolean;
    isDisabled?: boolean;
}

export const isReportEntryItem = (item: IReportItem): item is IReportEntryItem => item.type === ReportItemType.ReportEntry;
export const isReportEntryGroupItem = (item: IReportItem): item is IReportEntryItemGroup => item.type === ReportItemType.ReportEntryGroup;

interface ReportItemHeaderProps {
    label: string;
}

export const ReportItemHeader = (props: ReportItemHeaderProps): JSX.Element => {
    return (
        <CardletLabel>{props.label}</CardletLabel>
    )
}

interface ReportItemFooterProps {
    item: IReportEntryItem;
}

export const ReportItemFooter = (props: ReportItemFooterProps): JSX.Element => {
    const { isSelected } = props.item;

    return (
        <FooterRoot>
            <CardBindingSuggestions entryId={props.item.entry.id} isEntrySelected={isSelected} />
        </FooterRoot>
    )
}
